export enum UserRole {
  user = 0,
  admin = 1,
}


export const token = "TOKEN"
export const role = "ROLE"